import React, { Component } from 'react';
import * as ReactDOM from "react-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from 'react';
import axios from 'axios';
import { variables } from '../Variables';
import { useSelector } from "react-redux";

import mindfreeLogo from '../assets/images/login_Logo.svg';
import placeholderLarge from '../assets/images/prop-placeholder-lg.jpg';
import locationPin from '../assets/images/location-pin.svg';
import bedIcon from '../assets/images/bed-duo.svg';
import showerIcon from '../assets/images/shower-duo.svg';
import liftIcon from '../assets/images/lift-duo.svg';

export const WaitingList = () => {

    const { internalId, contactLanguage, estateId, clientId } = useParams();

    const [eventStatus, setEventStatus] = useState("");
    const [confirmProcessStart, setConfirmProcessStart] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLanguageTranslations, setSelectedLanguageTranslations] = useState(null);
    const [getContactStatus, setGetContactStatus] = useState(false);

    // Static property data — replace with API call when ready
    const [property, setProperty] = useState([]);

    const getLanguageTranslations = async () => {
        setIsLoading(true);
        try {
            const url = variables.API_URL + `Settings/GetTranslationsForSiteByLang?siteName=agent`;

            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                let translations = response.data;
                if (Object.keys(translations).length > 0) {
                    let agentTranslation = translations[contactLanguage || "en-GB"];
                    setSelectedLanguageTranslations(agentTranslation);
                    const contactStatusInWaitingList = await getContactStatusInWaitingList();
                    setGetContactStatus(contactStatusInWaitingList);
                    //await getEstateDetailFromLocalDB();
                    await getWhiseToken();
                }
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getLanguageTranslations("en-GB");
    }, []);

    const getContactStatusInWaitingList = async () => {
        try {
            const url = variables.API_URL + `LocalEvents/GetContactStatusInWaitingList?primaryKeyId=${internalId}`;

            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    const closePage = () => {
        window.close();
    }

    const processStart = async () => {
        setConfirmProcessStart(false);
        setIsLoading(true);
        try {
            const url = variables.API_URL + `LocalEvents/RemoveEntryFromWaitingList`;

            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const body = {
                "waitingListEntryId": internalId
            }

            const response = await axios.post(url, body, jsonconfig) // ASP.NET Core API endpoint with headers

            if (response.data) {
                console.log(response.data);
                setIsLoading(false);
                setEventStatus("success");
            }

        } catch (error) {
            console.log(error);
            setEventStatus("error");
            setIsLoading(false);
        }
    }

    const processReject = () => {
        setConfirmProcessStart(false);
        setIsLoading(false);
        setEventStatus("processReject");
    }

    //const getEstateDetailFromLocalDB = async () => {
    //    try {
    //        const url = variables.API_URL + `Estate/GetEstateDetail?estateId=${estateId}`;

    //        const jsonconfig = {
    //            headers: {
    //                'Content-Type': 'application/json'
    //            }
    //        };

    //        const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
    //        if (response.data.data != undefined) {
    //            setProperty([response.data.data]);
    //            setIsLoading(false);
    //            setConfirmProcessStart(true); // show UI only after local DB data is ready
    //        } else {
    //            await getWhiseToken();
    //        }
    //    } catch (error) {
    //        setEventStatus("api error");
    //        setIsLoading(false);
    //    }
    //}

    // get whise token
    const getWhiseToken = async () => {
        let url = "https://mink-mtsi-api.net7.be/api/User/GetWhiseTokenPerApp?appName=smartCal";
        let headers = {
            'Content-Type': 'application/json'
        };

        try {
            let resp = await axios.post(url, {},
                {
                    headers: headers
                });
            if (resp && resp.data && resp.data.token) {
                //console.log(resp.data.token);
                await getClientWhiseToken(resp.data.token);
            }
        }
        catch (e) {
            console.log(e);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    // get whise client token
    const getClientWhiseToken = async (whiseToken) => {
        try {
            let url = `https://mink-mtsi-api.net7.be/api/User/GetWhiseClientTokenByAccountTypeForOtherSites?whiseToken=${whiseToken}&clientId=${clientId}&accountType=WebDesigner`; // clientId

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.post(url, {}, config);

            if (response.data) {
                await getEstateDetailFromWhise(response.data.token);
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    // get estate detail from whise
    const getEstateDetailFromWhise = async (clientToken) => {
        try {
            let url = "https://api.whise.eu/v1/estates/list";

            const config = {
                headers: {
                    'Authorization': `Bearer ${clientToken}`,
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.post(url, {
                "Filter": {
                    EstateIds: [estateId]
                }
            }, config)

            if (response.data) {
                //console.log(response.data);
                response.data.estates[0].urlSmall = response.data.estates[0].pictures[0].urlLarge;
                console.log(response.data);
                setProperty(response.data.estates);
                setIsLoading(false);
                setConfirmProcessStart(true); // ✅ show UI only after Whise data is ready
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100vh" }}>
                <img src={mindfreeLogo} className="mb-4" alt="mindfree logo" />
                {
                    getContactStatus ?
                        <div className="confirmation-message-container text-center">
                            <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["actionAlreadyTakenError"] : "Sorry, we are unable to process your request because the specified action has already been taken."}</h6>
                            <button className="site-btn-padd close-page-btn w-25" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                        </div>
                        :
                        confirmProcessStart ?
                            <div>
                                {/* Property Card */}
                                {
                                    property.length > 0 ?
                                        property.map((item, index) => (
                                            <div key={index}>
                                                <div className="form-container form-container-expanded room-info mb-4">
                                                    <div className="row align-items-center">
                                                        <div className="col-6">
                                                            <div className="modal-img-container bg-black bor w-100">
                                                                {
                                                                    item !== undefined && item.urlSmall != ""
                                                                        ? <img src={item.urlSmall} className="property-img" alt="property" />
                                                                        : <img src={placeholderLarge} className="property-img" alt="placeholder" />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-6">
                                                            <p className="mb-0 denail-property-name">
                                                                {item.name != null ? item.name : "Property Name"}
                                                            </p>
                                                            <div className="denail-property-address d-flex align-items-center mt-2 mb-4">
                                                                <img src={locationPin} className="small-img-modal me-2" alt="location" />
                                                                <p className="mb-0">
                                                                    {
                                                                        (item.address ?? "") + " " +
                                                                        (item.number ?? "") + ", " +
                                                                        (item.zip ?? "") + " " +
                                                                        (item.city ?? "")
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="d-flex justify-content-between">
                                                                <p className="d-flex align-items-center mb-0">
                                                                    <img src={bedIcon} className={item.rooms ? "me-2" : ""} alt="beds" />
                                                                    <span className="smallImgIcon-Modal-info">{item.rooms || ""}</span>
                                                                </p>
                                                                <span className="border-end"></span>
                                                                <p className="d-flex align-items-center mb-0">
                                                                    <img src={showerIcon} className={item.bathRooms ? "me-2" : ""} alt="baths" />
                                                                    <span className="smallImgIcon-Modal-info">{item.bathRooms || ""}</span>
                                                                </p>
                                                                <span className="border-end"></span>
                                                                <p className="d-flex align-items-center mb-0">
                                                                    <img src={liftIcon} className={item.area ? "me-2" : ""} alt="area" />
                                                                    {item.area ? <span className="smallImgIcon-Modal-info">{item.area}m<sup>2</sup></span> : <span className="smallImgIcon-Modal-info"></span>}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        : <></>
                                }

                                <h6 className="fw-bold mb-4 text-center">{selectedLanguageTranslations ? selectedLanguageTranslations["doYouWantToTakeAction"] : "Do you want to take action?"}</h6>
                                <div className="text-center">
                                    <button className="sm-accept-pg-btn site-btn-red site-btn-padd me-3 mb-3" onClick={processReject}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["settingsPageNoRadioLbl"] : "No"}</button>
                                    <button className="sm-accept-pg-btn site-btn site-btn-padd mb-3" onClick={processStart}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}</button>
                                </div>
                            </div>
                            :
                            <div className="confirmation-message-container text-center">

                                {
                                    isLoading ?
                                        <>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                        :
                                        eventStatus != "" && eventStatus == "success" ?
                                            <>
                                                <h6 className="fw-bold mb-2">{selectedLanguageTranslations != null ? selectedLanguageTranslations["processSuccessfullyCompleted"] : "The process has been successfully completed."}</h6>
                                                <h6 className="fw-bold mb-3">{selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationScreenYouMayCloseThisPageText"] : "You may close this page."}</h6>
                                                <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                            </>
                                            : eventStatus != "" && eventStatus == "error" ?
                                                <>
                                                    <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["somethingWentWrong"] : "Something went wrong. Please try again later."}</h6>
                                                    <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                </>
                                                : eventStatus != "" && eventStatus == "processReject" ?
                                                    <>
                                                        <h6 className="fw-bold mb-2">{selectedLanguageTranslations != null ? selectedLanguageTranslations["noNotificationEstateSlot"] : "No notification was sent regarding the estate slot."}</h6>
                                                        <h6 className="fw-bold mb-3">{selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationScreenYouMayCloseThisPageText"] : "You may close this page."}</h6>
                                                        <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                    </>
                                                    :
                                                    <></>
                                }
                            </div>
                }
            </div>


        </>
    )
}

